import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type ActivationRequestResponse } from '../types';

import { type UpdateActivationAutoFollowUpPayload } from './types';
import {
  zodActivationRequestResponseSchema,
  zodUpdateActivationAutoFollowUpPayloadSchema,
} from './validations';

/**
 * Enables or disables automatic follow-up for an activation request batch.
 *
 * @param reqId - An activation request ID in the affected batch.
 * @param payload - The automatic follow-up state to apply.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The updated activation request.
 */
export const updateActivationAutoFollowUp = async (
  reqId: UUID,
  payload: UpdateActivationAutoFollowUpPayload,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .patch(ENDPOINT.SUPPLIER.UPDATE_ACTIVATION(reqId), {
      ...options,
      json: payload,
      validate: {
        ...options?.validate,
        body: zodUpdateActivationAutoFollowUpPayloadSchema,
        response: zodActivationRequestResponseSchema,
      },
    })
    .json<ActivationRequestResponse>();
